export const GAME_WIDTH = 800;
export const GAME_HEIGHT = 600;

export const SCENES = {
  PRELOAD: 'PreloadScene',
  MAIN_MENU: 'MainMenuScene',
  POKEMON_DEMO: 'PokemonDemoScene',
} as const;

export const SPRITE_SOURCES = {
  POKEAPI: 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/',
  POKESPRITE: 'https://raw.githubusercontent.com/msikma/pokesprite/master/pokemon-gen8/',
} as const;

export const POKEMON_DEMO_DATA = [
  { id: 25, name: 'Pikachu', types: ['Electric'] },
  { id: 6, name: 'Charizard', types: ['Fire', 'Flying'] },
  { id: 1, name: 'Bulbasaur', types: ['Grass', 'Poison'] },
  { id: 7, name: 'Squirtle', types: ['Water'] },
  { id: 133, name: 'Eevee', types: ['Normal'] },
];
